import * as React from 'react';
import {cn} from '@/lib/utils';

export interface TextProps extends React.HTMLAttributes<HTMLSpanElement> {
  type?: 'secondary' | 'success' | 'warning' | 'danger';
  strong?: boolean;
  mark?: boolean;
  code?: boolean;
  keyboard?: boolean;
  underline?: boolean;
  delete?: boolean;
  italic?: boolean;
}

const Text = React.forwardRef<HTMLSpanElement, TextProps>(
  (
    {
      className,
      type,
      strong,
      mark,
      code,
      keyboard,
      underline,
      delete: del,
      italic,
      ...props
    },
    ref,
  ) => {
    const typeClasses = {
      secondary: 'text-muted-foreground',
      success: 'text-color-(--constructive)',
      warning: 'text-color-(--warning)',
      danger: 'text-destructive',
    };

    const elementClasses = {
      strong: 'font-semibold',
      mark: 'bg-yellow-200 px-1 rounded',
      code: 'bg-gray-100 px-1 rounded font-mono text-sm',
      keyboard: 'bg-gray-100 px-1 rounded font-mono text-sm border',
      underline: 'underline',
      delete: 'line-through',
      italic: 'italic',
    };

    const classes = [];
    if (type) classes.push(typeClasses[type]);
    if (strong) classes.push(elementClasses.strong);
    if (mark) classes.push(elementClasses.mark);
    if (code) classes.push(elementClasses.code);
    if (keyboard) classes.push(elementClasses.keyboard);
    if (underline) classes.push(elementClasses.underline);
    if (del) classes.push(elementClasses.delete);
    if (italic) classes.push(elementClasses.italic);

    return <span ref={ref} className={cn(classes, className)} {...props} />;
  },
);
Text.displayName = 'Text';

export {Text};
